import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { IMAGE_DNS } from "utils/config/Config";
import { BASE_PATH, CommentData } from "api/commonApi";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  headersState,
  isLoginStateSelector,
  userInfoState
} from "recoil/userInfoAtom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsis,
  faPen,
  faTrashCan
} from "@fortawesome/free-solid-svg-icons";
import parse from "html-react-parser";
import {
  editCommentNumState,
  isEditState,
  isProfilePageState,
  parentsIdxState,
  popState,
  writingTypeState
} from "recoil/contentsAtom";
import { useLoginCheck } from "hooks/useLoginCheck";
import { useMutation, useQueryClient } from "react-query";
import { CommentsDeleteApi } from "api/replyApi";
import { useState } from "react";
import md5 from "md5";

interface IProps {
  data: CommentData;
  type: string;
}

function ReplyFrame(props: IProps) {
  const { data, type } = props;
  const { t } = useTranslation();
  const userInfo = useRecoilValue(userInfoState);
  const headers = useRecoilValue(headersState);
  const isLoginState = useRecoilValue(isLoginStateSelector);
  const isProfilePage = useRecoilValue(isProfilePageState);
  const setIsEdit = useSetRecoilState(isEditState);
  const setEditCommentNumState = useSetRecoilState(editCommentNumState);
  const setParentsIdx = useSetRecoilState(parentsIdxState);
  const setPopOpen = useSetRecoilState(popState);
  const setWritingType = useSetRecoilState(writingTypeState);
  const [editingToggle, setEditingToggle] = useState<any>({});
  const isNotLogin = useLoginCheck();
  const navigate = useNavigate();

  const openRereply = (idx: number) => {
    if (!isLoginState.isLogIn) {
      isNotLogin();
    } else {
      setParentsIdx(idx);
      setPopOpen(true);
      setWritingType("reply");
      setIsEdit(false);
    }
  };

  const handleArticleEditor = (idx: number) => {
    setEditingToggle({
      [idx]: !editingToggle[idx]
    });

    if (!isLoginState.isLogIn) {
      isNotLogin();
    }
  };

  const useDeleteMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(CommentsDeleteApi, {
      onSuccess: (api) => {
        queryClient.invalidateQueries([type]);
        if (api.data.result !== 1) {
          alert(t(api.data.msg));
        }
      },
      onError: (error: any) => {
        alert(t(error.response.data.message));
      }
    });
  };

  const { mutate: deleteMutate } = useDeleteMutation();

  const deleteBoard = (board_idx: number, comment_idx: number) => {
    const deleteApi = isProfilePage
      ? `${BASE_PATH}/api/vfunlounge/profile/post/comment?comment_idx=${comment_idx}`
      : `${BASE_PATH}/api/vfunlounge/comments/${board_idx}/${comment_idx}`;

    if (window.confirm(t("Would_you_like_to_delete_your_reply"))) {
      const props = { deleteApi, headers };
      deleteMutate(props);
    } else {
      return false;
    }
  };

  const editBoard = (idx: number) => {
    setWritingType("reply");
    setIsEdit(true);
    setPopOpen(true);
    setEditCommentNumState(idx);
  };

  const onClickNickname = (userSerial: number, userId: string) => {
    const profileKey = md5(`${userSerial}/${userId}`);
    navigate(`/profile/${profileKey}/post`);
  };

  return (
    <div className={`${type} box`}>
      <div className="info clearfix">
        {/* 유저 프로필 사진 필요 */}
        <img
          className="user-pic"
          src={
            data.admin_flag === 1
              ? data.admin_icon
              : data.profile_image_url_from === "" ||
                data.profile_image_url_from === null
              ? IMAGE_DNS +
                "/Valofe_file/web/vfun-ko/images/common/img-user-default-min.png"
              : data.profile_image_url_from
          }
          alt="profile-default"
        />
        <span className="nickname">
          <span
            className="name"
            onClick={() => onClickNickname(data.user_Serial, data.user_id)}
          >
            {data.user_nickname}
          </span>
          {Number(data.user_Serial) === userInfo.userSerial ? (
            <FontAwesomeIcon
              icon={faEllipsis}
              onClick={(e) => handleArticleEditor(data.idx)}
            />
          ) : null}

          {editingToggle[data.idx] ? (
            <ul className="editing">
              <li className="edit" onClick={() => editBoard(data.idx)}>
                <FontAwesomeIcon icon={faPen} />
                {t("edit")}
              </li>
              <li
                className="delete"
                onClick={() => deleteBoard(data.board_idx, data.idx)}
              >
                <FontAwesomeIcon icon={faTrashCan} />
                {t("delete")}
              </li>
            </ul>
          ) : null}
        </span>
      </div>

      <div className="reply-bottom">
        <div className="txt">{parse(data.comment)}</div>
        <ul>
          {data.images !== null && data.images.length !== 0 ? (
            <div style={{ width: "100%", paddingTop: "6px" }}>
              <img src={data.images[0]} className="re-reply-img" />
            </div>
          ) : null}
          {type === "reply" && (
            <li className="re-reply-btn">
              <Link to="#" onClick={() => openRereply(data.idx)}>
                {t("write_a_comment")}
              </Link>
            </li>
          )}
          <li className="time">{data.created_at}</li>
        </ul>
      </div>
    </div>
  );
}

export default ReplyFrame;
